module.exports = __webpack_public_path__ + "img/wheelchair.8b7c1f14.svg";